import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";
import { CouponCodeRequest } from "../../../../orchestrator-api-client";

export const submitCouponCodeReducer = (
  state: LoanState,
  action: PayloadAction<CouponCodeRequest>,
) => {
  state.coupon = action.payload.couponCode ?? "";
};
